export default "__VITE_ASSET__B4caHi3e__"